// src/components/FormInput/FormInput.jsx
import React from 'react';
import styles from './FormInput.module.css';

const FormInput = ({
  label,
  id,       // Important for linking label to input
  name,     // Input name attribute
  type = 'text',
  value,    // Controlled component value
  onChange, // Controlled component handler
  placeholder,
  required = false,
  error,    // Pass error message string if validation fails
  className = '', // Allow passing extra custom classes to the wrapper
  inputClassName = '', // Allow passing extra classes to the input itself
  ...props  // Pass other input attributes (e.g., autoComplete)
}) => {
  // Ensure id is available for the label's htmlFor
  const inputId = id || name;

  return (
    // Use formGroup class from Login styles for consistency
    <div className={`${styles.formGroup} ${className}`}>
      {label && (
        <label htmlFor={inputId} className={styles.label}>
          {label}
          {required && <span className={styles.requiredMark}>*</span>}
        </label>
      )}
      <input
        type={type}
        id={inputId}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        // Combine internal and external classes, add error class if error exists
        className={`
          ${styles.inputField}
          ${error ? styles.hasError : ''}
          ${inputClassName}
        `.trim()}
        {...props}
      />
      {/* Display error message if provided */}
      {error && <div className={styles.errorMessage}>{error}</div>}
    </div>
  );
};

export default FormInput;